import controller from './users.controller';

const template = require('./users.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/users.component.js